var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerifiedPost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.85312 8.62303C3.70716 7.96555 3.72958 7.28187 3.91828 6.63537C4.10698 5.98886 4.45587 5.40047 4.93259 4.92475C5.40931 4.44902 5.99843 4.10137 6.64533 3.91402C7.29223 3.72667 7.97596 3.70569 8.63312 3.85303C8.99483 3.28733 9.49313 2.82179 10.0821 2.49931C10.671 2.17684 11.3317 2.00781 12.0031 2.00781C12.6746 2.00781 13.3352 2.17684 13.9242 2.49931C14.5131 2.82179 15.0114 3.28733 15.3731 3.85303C16.0313 3.70505 16.7162 3.72594 17.3641 3.91374C18.012 4.10155 18.602 4.45017 19.079 4.92718C19.556 5.40419 19.9046 5.9941 20.0924 6.64203C20.2802 7.28996 20.3011 7.97486 20.1531 8.63303C20.7188 8.99474 21.1844 9.49303 21.5068 10.082C21.8293 10.6709 21.9983 11.3316 21.9983 12.003C21.9983 12.6745 21.8293 13.3351 21.5068 13.9241C21.1844 14.513 20.7188 15.0113 20.1531 15.373C20.3005 16.0302 20.2795 16.7139 20.0921 17.3608C19.9048 18.0077 19.5571 18.5968 19.0814 19.0736C18.6057 19.5503 18.0173 19.8992 17.3708 20.0879C16.7243 20.2766 16.0406 20.299 15.3831 20.153C15.0219 20.7209 14.5232 21.1884 13.9332 21.5123C13.3433 21.8363 12.6811 22.0061 12.0081 22.0061C11.3351 22.0061 10.6729 21.8363 10.083 21.5123C9.49304 21.1884 8.99436 20.7209 8.63312 20.153C7.97596 20.3004 7.29223 20.2794 6.64533 20.092C5.99843 19.9047 5.40931 19.557 4.93259 19.0813C4.45587 18.6056 4.10698 18.0172 3.91828 17.3707C3.72958 16.7242 3.70716 16.0405 3.85312 15.383C3.28308 15.0223 2.81354 14.5232 2.48817 13.9322C2.16281 13.3413 1.99219 12.6776 1.99219 12.003C1.99219 11.3284 2.16281 10.6648 2.48817 10.0738C2.81354 9.48285 3.28308 8.98378 3.85312 8.62303Z",
    fill: "#91172C",
    stroke: "#91172C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9 12L11 14L15 10",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedPost);
export default __webpack_public_path__ + "static/media/verifiedPost.b4d5fed1551932ccca156c1e91a7f5d8.svg";
export { ForwardRef as ReactComponent };